import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { renderRoutes } from 'react-router-config'
import { NavLink } from 'react-router-dom'
import { Menu } from 'semantic-ui-react'
import { firebaseConnect } from 'react-redux-firebase'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { getIsAuthenticated } from 'store/selectors'

const Container = styled.div`
  height: 100%;
`

@firebaseConnect()
@connect(state => ({
  isAuthenticated: getIsAuthenticated(state)
}))
class Root extends Component {
  static propTypes = {
    firebase: PropTypes.shape({
      logout: PropTypes.func.isRequired
    }),
    route: PropTypes.shape({
      routes: PropTypes.arrayOf(PropTypes.object)
    }),
    isAuthenticated: PropTypes.bool
  }

  state = {
    isLoading: false
  }

  logout = async () => {
    this.setState({ isLoading: true })
    try {
      await this.props.firebase.logout()
      this.setState({ isLoading: false })
    } catch (error) {
      this.setState({ isLoading: false })
    }
  }

  render () {
    const { isAuthenticated } = this.props
    return (
      <Container>
        {isAuthenticated && (
          <Menu pointing secondary color='red' className='dont-print'>
            <Menu.Menu>
              <Menu.Item
                as={NavLink}
                name='Neue Registrierung'
                to='/add'
                exact
              />
            </Menu.Menu>
            <Menu.Menu position='right'>
              <Menu.Item name='Ausloggen' onClick={this.logout} />
            </Menu.Menu>
          </Menu>
        )}
        {/* child routes won't render without this */}
        {renderRoutes(this.props.route.routes)}
      </Container>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/routes/Root/index.js